/**
 * Starts: element top >= scrollPositionBbottom
 * Ends: element bottom <= scrollPosition
 *
 * values:
 *		progress 0-1
 *		distance px
 *
 * @param {node} element
 * @param {object} dimensions - the element dimensions (height, width, top etc..)
 * @param {object} scrollPosition - the current x and y
 * @param {number} windowHeight
 * @param {number} documentHeight
 * @param {object} preferences - objects passed through, enabling reusing views
 *
 * @return {object} - with the progress (%) and distance (px)
 */
function outerView(element, dimensions, scrollPosition, windowHeight, documentHeight, preferences) {
	// Bottom position
	const elementOffsetBottom = dimensions.height + dimensions.top;

	// The distance between start and stop
	let range = windowHeight + dimensions.height;

	// foldOffset makes sure, that even if an element is above the fold,
	// the progress starts at 0 - it basicly just shortens the range
	if (preferences.foldOffset) {
		range -= dimensions.top < windowHeight ? windowHeight - dimensions.top : 0;
	}

	// distance traveled (px)
	const distance = range - (elementOffsetBottom - scrollPosition.y);

	// The progress in percentage
	let progress = distance / range;

	// bottomOffset is a bit like foldOffset, it just makes
	// sure the progress reaces 1 when bottom of the page is reached
	if (preferences.bottomOffset) {
		const bottomOffset = documentHeight - dimensions.top;
		const multiplier = range / bottomOffset;

		if (bottomOffset < range) {
			progress *= multiplier;
		}
	}

	if (preferences.cap) {
		progress = Math.min(Math.max(progress, 0), 1);
	}

	// Returns an object, with distance and progress,
	// which is passed to the callback function
	return {
		progress,
		distance: range * progress,
	};
}

export default outerView;



// WEBPACK FOOTER //
// ./scripts/sky-visible/utilities/outerView.js